// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Io-z","badgeLink":"Jo-z","category":"Ko-z"};